export default __webpack_public_path__ + "static/media/work.d8a04b0c.png";